type LabModalPopupAction = 'impression' | 'primary_cta_click' | 'secondary_cta_click' | 'dismiss'

interface LabModalPopupEventParams {
  popup: App.LabModalPopupResult
  action: LabModalPopupAction
}

export async function labModalPopupEvent(params: LabModalPopupEventParams): Promise<void> {
  const { popup, action } = params
  const modalId = popup.id
  const { trackClientEvent } = await import('analytics/analytics')

  trackClientEvent({
    subject: `lab_modal_popup_${modalId}`,
    action,
    category: 'lab_modal_popup',
    type: action === 'impression' ? 'nonInteraction' : 'interaction',
  })
}
